// btw-front/src/components/ui/Button.jsx
import React from "react";

export function Button({
  variant = "primary",
  size = "md",
  className = "",
  href,
  type = "button",
  onClick,
  disabled = false,
  loading = false,
  children,
}) {
  const cls =
    variant === "ghost"
      ? "btw-btn-ghost"
      : variant === "ghost-invert"
        ? "btw-btn-ghost-invert"
        : variant === "link"
          ? "btw-link"
          : variant === "accent"
            ? "btw-btn-accent"
            : "btw-btn-primary";

  // 컴팩트 사이즈: 기본 pill(rounded-full/py-3) 대신 contextual 액션용 작은 버튼
  // (딜 상세 메모 저장 등). 유틸리티 important 로 btw-btn 베이스 값을 덮어쓴다.
  const sizeCls = size === "sm" ? "!rounded-lg !py-2.5" : "";

  // loading 중에는 중복 클릭 방지를 위해 disabled 처리.
  const isDisabled = disabled || loading;

  const Comp = href ? "a" : "button";
  const props = href ? { href } : { type, onClick, disabled: isDisabled };

  return (
    <Comp
      className={`${cls} ${sizeCls} ${isDisabled ? "cursor-not-allowed opacity-50" : ""} ${className}`}
      {...props}
    >
      {loading && (
        <span
          className="h-4 w-4 animate-spin rounded-full border-2 border-current border-r-transparent opacity-70"
          aria-hidden="true"
        />
      )}
      {children}
    </Comp>
  );
}
